import { useCallback, useEffect, useRef, useState } from 'react';

const getImageRatio = (
  url: string | null
): Promise<{ ratio: number; isLandscape: boolean } | undefined> =>
  new Promise(resolve => {
    if (!url) return resolve(undefined);
    const img = new Image();
    img.addEventListener(
      'load',
      () => {
        const value = (img.height / img.width) * 100;
        return resolve({ ratio: value, isLandscape: img.width > img.height });
      },
      false
    );
    img.addEventListener(
      'error',
      (e: Event) => {
        return resolve(undefined);
      },
      false
    );
    img.src = url;
  });

export const useImageRatio = (url?: string | null) => {
  const mounted = useRef<boolean>(false);

  const [ratio, setRatio] = useState<number>();
  const [isLandscape, setIsLandscape] = useState<boolean>(false);

  const getRatio = useCallback(async (url: string) => {
    const imageProperties = await getImageRatio(url);
    if (mounted.current) {
      setRatio(imageProperties?.ratio);
      setIsLandscape(!!imageProperties?.isLandscape);
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    if (url) {
      getRatio(url);
    }
    return () => {
      mounted.current = false;
    };
  }, [getRatio, url]);

  return { ratio, isLandscape };
};
